<template>
  <div>
    <div
      class="text-center font-weight-regular px-5 py-0"
      style="color: #888"
    >
      <font size="1">Powered by Ocular</font>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class OcularSign extends Vue {}
</script>
